import { useEndsOfYScroll } from '__components/Kizen/LazyLoad/helpers';
import { useRef } from 'react';
import { StyledFullscreenModal } from '../../SmartConnectorWizard/styles';
import { SubNavigation } from './SubNavigation';
import { Steps } from './steps';
import { Header } from './Header';
import { PrimaryObjectUploadProvider } from './PrimaryObjectUploadProvider';
import { ConfirmationManager } from './ConfirmationManager';
import { WithMobileWarning } from 'pages/SmartConnectors/components/WithMobileWarning';

export const PrimaryObjectUploadWizard = () => {
  const bodyRef = useRef<HTMLDivElement>(null);
  const [scrolledTop] = useEndsOfYScroll(bodyRef, []);

  return (
    <PrimaryObjectUploadProvider>
      <StyledFullscreenModal
        ref={bodyRef}
        show
        enforceFocus={false}
        header={<Header scrolledTop={scrolledTop} />}
        scrolledTop={scrolledTop}
      >
        <WithMobileWarning>
          <SubNavigation />
          <Steps />
        </WithMobileWarning>
      </StyledFullscreenModal>
      <ConfirmationManager />
    </PrimaryObjectUploadProvider>
  );
};
